module.exports = __webpack_public_path__ + "static/media/star_company.7f08fee1.svg";